import { Predicate } from '@standardnotes/models';
import { ContentType, Result } from '@standardnotes/domain-core';
export class FindContact {
    constructor(items) {
        this.items = items;
    }
    execute(query) {
        if ('userUuid' in query && query.userUuid) {
            const contacts = this.items.itemsMatchingPredicate(ContentType.TYPES.TrustedContact, new Predicate('contactUuid', '=', query.userUuid));
            if (contacts.length === 0) {
                return Result.fail(`Contact not found for user ${query.userUuid}`);
            }
            if (contacts.length > 1) {
                return Result.fail(`Multiple contacts found for user ${query.userUuid}`);
            }
            return Result.ok(contacts[0]);
        }
        if ('signingPublicKey' in query && query.signingPublicKey) {
            const allContacts = this.items.getItems(ContentType.TYPES.TrustedContact);
            const contact = allContacts.find((contact) => contact.hasCurrentOrPreviousSigningPublicKey(query.signingPublicKey));
            if (contact) {
                return Result.ok(contact);
            }
            else {
                return Result.fail('Contact not found');
            }
        }
        throw new Error('Invalid query');
    }
}
